var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-icon',{class:_vm.styles,attrs:{"name":_vm.icon}})
}
var staticRenderFns = []

export { render, staticRenderFns }